import { Event } from 'three';
import { $ } from '@/Engine/state';
import { eventsNumLimit } from '@/Constants/common';
import { onPointerMove } from '@/Engine/eventHandlers/onPointerMove';

export const onDragOverHandler = (e: Event) => {
    e.preventDefault();
    // TODO
    $.dndMode = true;
    onPointerMove(e);
};
